<template>
    <v-card>
        <v-toolbar flat color="primary" dark>
            <v-toolbar-title>{{ trans('document-checklist.upload-title') }}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-list>
            <template v-for="k in ['title', 'description', 'category']">
                <v-list-item :key="`item.${k}`">
                    <v-list-item-content>
                        <v-list-item-title>{{ value[k] }}</v-list-item-title>
                        <v-list-item-subtitle>{{ trans(`document-checklist.fields.${k}`) }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
        </v-list>
        <v-card-text>
            <p>{{ trans('document-checklist.upload-descr') }}</p>
            <error-badge v-model="error" />
            <v-form ref="form" v-model="validForm">
                <div :class="{ drop_zone: true, dragging: isDragging }" @dragover="dragover" @dragleave="dragleave"
                    @drop="onDrop">
                    "
                    <v-file-input v-model="file" prepend-icon="attach_file" show-size
                        accept=".pdf,.jpg,.png,.p7m,.zip,.7z,.rar" :rules="rules.file"
                        :label="trans('document-checklist.fields.file')" v-bind="{ loading: isLoading }" />
                </div>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="close" v-bind="{ loading: isLoading, }" outlined color="secondary"><v-icon
                    left>close</v-icon>{{
                trans('common.close')
            }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="submit" v-bind="{ loading: isLoading, disabled: !canSubmit }" outlined
                color="primary"><v-icon left>send</v-icon>{{
                trans('common.submit')
                }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        projectId: { type: Number, required: true, },
        value: { type: Object, required: true },
    },
    data() {

        const maxSize = 50 * 1024 * 1024;//50mb

        return {
            file: null,

            rules: {
                file: [
                    v => !!v || trans('validation.required', { attribute: '' }),
                    value => !value || value.size < maxSize || trans('validation.max.file', { max: maxSize / 1024, attribute: '' }),
                ]
            },
            validForm: false,

            procesing: false,
            error: null,


            isDragging: false,
        }
    },
    computed: {
        canSubmit() {
            return !this.disabled && this.validForm;
        },
        isLoading() {
            return this.procesing || this.loading;
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async submit() {
            console.warn('file', this.file);
            // prepare file
            const formData = new FormData();
            formData.append('file', this.file);
            formData.append('_method', 'put');
            //
            this.processing = true;
            this.error = null;

            try {
                const r = await axios.post(`/projects/${this.projectId}/document-list/${this.value.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                this.$emit('submit');

            } catch (e) {
                this.error = e;
            } finally {
                this.processing = false;
            }
        },
        onDrop(e) {
            e.preventDefault();
            this.file = e.dataTransfer.files[0];

            this.isDragging = false;

        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
    },

}
</script>
<style scoped type="scss">
.drop_zone {
    border: 2pt dashed #9C27B0;
    border-radius: 5px;
    padding: 15pt 10pt;
    text-align: center;

    &.dragging {
        background: #9C27B0;
        border: 2pt dashed white;

        * {
            opacity: 0.5;
        }

        &:before {
            content: 'Rilascia qui il file';
            opacity: 1;
            color: white;
            font-size: 20pt;
            text-align: center;
        }
    }
}
</style>